export type BannerTransitionType = "crossfade" | "slide" | "flip" | "reveal";

const TRANSITION_ENTER_CLASSES: Record<BannerTransitionType, string> = {
  crossfade: "animate-banner-crossfade-in",
  slide: "animate-banner-slide-in",
  flip: "animate-banner-flip-in",
  reveal: "animate-banner-reveal-in",
};

const TRANSITION_EXIT_CLASSES: Record<BannerTransitionType, string> = {
  crossfade: "animate-banner-crossfade-out",
  slide: "animate-banner-slide-out",
  flip: "animate-banner-flip-out",
  reveal: "animate-banner-reveal-out",
};

export const getBannerTransitionEnterClass = (type: BannerTransitionType) => TRANSITION_ENTER_CLASSES[type];

export const getBannerTransitionExitClass = (type: BannerTransitionType) => TRANSITION_EXIT_CLASSES[type];

export const getBannerTransitionContainerClass = (type: BannerTransitionType) => {
  if (type === "flip") {
    return "perspective-[1200px] [transform-style:preserve-3d]";
  }

  return "overflow-hidden";
};
